import React, { useState, useEffect, useRef } from "react";



const loadScript = (url, callback) => {

    let script;
    let exist = false;
    if (document.querySelectorAll('script[src="' + url + '"]').length > 0) {
        script = document.querySelectorAll('script[src="' + url + '"]')[0];
        exist = true;
    }
    else {
        script = document.createElement("script");
        script.type = "text/javascript";

    }
    
    
    if (window.google && window.google.maps && window.google.maps.places) {
            callback();
            
        
    } else {
        //script.onload = () => callback();
        script.addEventListener("load", function () {


            callback();
        })
    }
   
    if (!exist) {
       
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    }
    
};



/*

function SearchLocationInput2() {
    const [query, setQuery] = useState("");
    const autoCompleteRef = useRef(null);
    let autoComplete;
    useEffect(() => {
        loadScript(
            `https://maps.googleapis.com/maps/api/js?key=AIzaSyC77hx3YU-12HVvLpGJPH79amsjc55upuA&libraries=places`,
            () => handleScriptLoad(autoComplete,setQuery, autoCompleteRef)
        );
    }, []);

    let autcom= (
        <div className="search-location-input">
            <input
                ref={autoCompleteRef}
                onChange={event => setQuery(event.target.value)}
                
                placeholder=""
                value={query}
            />
        </div>
    );
    autcom.addEventListener.addEventListener("onPlaceSelected");

    return autcom;
}

export default SearchLocationInput2;*/

class SearchLocationInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = { query: this.props.defaultValue ? this.props.defaultValue:''};
        this.autoCompleteRef = React.createRef();
        
        this.handleScriptLoad = this.handleScriptLoad.bind(this);
        this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
        this.autoComplete = null;
    }
    componentDidMount() {

        loadScript(
            `https://maps.googleapis.com/maps/api/js?key=AIzaSyC77hx3YU-12HVvLpGJPH79amsjc55upuA&libraries=places`,
            () => this.handleScriptLoad()
        );

    }
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({ query: this.props.defaultValue});
        }
    }
    handleScriptLoad(updateQuery) {
        this.autoComplete = new window.google.maps.places.Autocomplete(
        this.autoCompleteRef.current,
        { types: ["address"], componentRestrictions: { country: "it" } }
        );
        this.autoComplete.setFields(["address_components", "formatted_address"]);
        this.autoComplete.addListener("place_changed", () =>
            this.handlePlaceSelect()
        );
    }
    handlePlaceSelect() {
        const addressObject = this.autoComplete.getPlace();

        let arr = ['premise', 'route', 'locality', 'postal_town', 'administrative_area_level_2', 'postal_code', 'country','street_number'];
        let dict = {};
        if (addressObject && addressObject.length)
            for (let i = 0; i < addressObject.length; i++)
                for (let j = 0; j < addressObject[i].types.length; j++)
                    if (arr.indexOf(addressObject[i].types[j] > -1))
                        dict[addressObject[i].types[j]] = addressObject[i]["short_name"];


        if (this.props.onPlaceSelected)
            this.props.onPlaceSelected(addressObject, dict);

        const query = dict.route ? dict.route : addressObject.formatted_address;
        this.setState({ query: query});

    }
    render() {

        return (<div className="search-location-input">
            <input
                ref={this.autoCompleteRef}
                onChange={event => this.setState({ query:event.target.value })}
                placeholder=""
                value={this.state.query}
            />
        </div>);
    }
};
export default SearchLocationInput;